"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const ListItem_1 = __importDefault(require("@material-ui/core/ListItem"));
const ListItemIcon_1 = __importDefault(require("@material-ui/core/ListItemIcon"));
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const makeStyles_1 = __importDefault(require("@material-ui/styles/makeStyles"));
const ExpandMore_1 = __importDefault(require("@material-ui/icons/ExpandMore"));
const UserAvatar_1 = __importDefault(require("./UserAvatar"));
const PopOverMenu_1 = __importDefault(require("./PopOverMenu"));
exports.default = react_1.default.memo(UserListItem, shouldSkipRerender);
UserListItem.defaultProps = {
    buttons: null,
    handleSelectUser: null
};
function shouldSkipRerender(p1, p2) {
    return p1.user.userId === p2.user.userId &&
        p1.user.username === p2.user.username &&
        p1.user.imageId === p2.user.imageId &&
        p1.user.isOnline === p2.user.isOnline;
}
const useStyles = makeStyles_1.default((theme) => ({
    container: {
        position: "relative",
        "&:hover .pop-over-menu-icon": {
            visibility: "visible"
        }
    },
    listItem: {
        backgroundColor: theme.colors.sidePanel.backgroundColor,
        "&:hover": {
            backgroundColor: theme.colors.sidePanel.listItemHoverBackgroundColor,
            cursor: "pointer"
        }
    },
    username: {
        paddingLeft: 10,
        width: "100%"
    },
    menu: {
        position: "absolute",
        padding: 6,
        top: 3,
        right: 3,
        visibility: "hidden"
    }
}));
const defaultOnClick = _ => { };
function UserListItem(props) {
    const classes = useStyles();
    let className = classes.container;
    let onClick = defaultOnClick;
    if (props.handleSelectUser) {
        className += " " + classes.listItem;
        onClick = handleClick;
    }
    function handleClick(event) {
        const element = event.target;
        const clickedOnPopOver = element.closest(".pop-over-menu-icon, .pop-over-menu") !== null;
        if (!clickedOnPopOver) {
            props.handleSelectUser();
        }
    }
    return (react_1.default.createElement(ListItem_1.default, { onClick: onClick, className: className, divider: true },
        react_1.default.createElement(ListItemIcon_1.default, null,
            react_1.default.createElement(UserAvatar_1.default, { userId: props.user.userId, imageId: props.user.imageId, isUserOnline: props.user.isOnline, size: "md" })),
        react_1.default.createElement(Typography_1.default, { variant: "body1", className: classes.username }, props.user.username),
        props.buttons
            ? react_1.default.createElement(PopOverMenu_1.default, { icon: react_1.default.createElement(ExpandMore_1.default, null), menuItems: props.buttons, placement: "bottom-end", className: classes.menu + " pop-over-menu-icon" })
            : null));
}
